module.exports = {
  title: `Bun Bottom`,
  image: require('./BunBottom.png'),
  height: 92,
  cost: 0.25,
  limit: 2,

  nutrition: {
    calories: 80,
    carbs: 14,
    fiber: 1,
    sugar: 2,
    fat: 2,
    protein: 3,
    sodium: 130,
    iron: 3,
  },

  collapsedStyle: {
    maxWidth: `90%`,
    marginTop: -50,
    marginBottom: 30,
    transform: `translateY(10%)`,
  },

  preparation: {
    limit: 2,
  },
}
